import { getUserInfoThunk } from "../store/auth/thunks";
import { useDispatch } from "../store/store";
import TagManager from 'react-gtm-module';
import { useEffect } from "react";
import ReactGA from 'react-ga4';


const GAID = process.env.REACT_APP_GA_ID;
const GTMID = process.env.REACT_APP_GTM_ID;

const tagManagerArgs = {
    gtmId: GTMID || '',
}

GAID && ReactGA.initialize(GAID || '');
GTMID && TagManager.initialize(tagManagerArgs);

export const useBootstrap = () => {
    const dispatch = useDispatch();
    const authState = localStorage.getItem('auth_status');

    useEffect(() => {
        if (!authState) {
            localStorage.clear();
        } else {
            dispatch(getUserInfoThunk());
        }
    }, []);
};
